import React from 'react';
import styled from 'styled-components';
import AppleLogo from '../SvgComponents/logos/AppleLogo';
import PlayStoreLogo from '../SvgComponents/logos/PlayStoreLogo';
import { CUSTOMER_APP } from '../../appLinks';

/* global tw */

const Group = styled.div`
    ${tw`inline-flex items-center`};
    gap: 0.5rem;
    ${props => props.hideOnMobile && tw`hidden lg:inline-flex`};
`

const StorePill = styled.a`
    ${tw`inline-flex items-center no-underline cursor-pointer`};
    gap: 0.5rem;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    letter-spacing: -0.005em;
    padding: 0.5rem 0.9rem;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.04);
    color: #F5F5F7 !important;
    border: 1px solid rgba(255, 255, 255, 0.10);
    transition: all 0.2s ease;
    ${props => props.dark && `
        background: rgba(10, 10, 15, 0.04);
        color: #1A1A2E !important;
        border: 1px solid rgba(26, 26, 46, 0.18);
    `};
    &:hover {
        background: rgba(177, 92, 255, 0.10);
        border-color: rgba(177, 92, 255, 0.45);
        color: ${props => (props.dark ? '#1A1A2E' : '#FFFFFF')} !important;
        transform: translateY(-1px);
    }
    &:active { transform: scale(0.97); }
`

class DownloadAppButton extends React.Component {
    handleClick = () => {
        // eslint-disable-next-line
        if (typeof analytics !== 'undefined') { analytics.track('Download App Clicked', { category: 'Download Button', label: 'Clicked' }); }
    }
    render() {
        const { dark, hideOnMobile, className, iosUrl, androidUrl } = this.props;
        const ios = iosUrl || CUSTOMER_APP.ios;
        const android = androidUrl || CUSTOMER_APP.android;
        return (
            <Group hideOnMobile={hideOnMobile} className={className}>
                <StorePill href={ios} target="_blank" rel="noopener noreferrer" onClick={this.handleClick} dark={dark}>
                    <AppleLogo dark={dark} height="18" />
                    App Store
                </StorePill>
                <StorePill href={android} target="_blank" rel="noopener noreferrer" onClick={this.handleClick} dark={dark}>
                    <PlayStoreLogo dark={dark} height="18" />
                    Google Play
                </StorePill>
            </Group>
        );
    }
}

export default DownloadAppButton;
